// extracted by mini-css-extract-plugin
export default {"stepperBlock":"StepperBlock_stepperBlock__8T9Xe","stepperList":"StepperBlock_stepperList__M8CwY","divider":"StepperBlock_divider__zWJtd"};